"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickarooEmbed1Schema = void 0;
exports.TickarooEmbed1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/tickaroo-embed/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TickarooEmbed1",
    "description": "A “live ticker” service that can be used for news or events reporting.",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:tickaroo-embed:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "clientId": {
                    "type": "string",
                    "description": "The unique identifier by Tickaroo to an organization's account. This can be used to organize and manage liveblogs associated with different Red Bull entities, such as Red Bull Racing or Red Bull Illume."
                },
                "liveblogId": {
                    "type": "string",
                    "description": "The ID used in order to identify which liveblog should be embedded."
                },
                "themeId": {
                    "type": "string",
                    "description": "The ID used to theme the liveblog accordingly. This will enable theming live blocks to match e.g.: WRC's design and color scheme."
                }
            },
            "required": [
                "clientId",
                "liveblogId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy90aWNrYXJvby1lbWJlZC8xLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLG9CQUFvQixHQUFHO0lBQ2xDLEtBQUssRUFBRSxtRkFBbUY7SUFDMUYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsZ0JBQWdCO0lBQ3pCLGFBQWEsRUFBRSx3RUFBd0U7SUFDdkYsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sMkNBQTJDO2FBQzVDO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLFlBQVksRUFBRTtnQkFDWixVQUFVLEVBQUU7b0JBQ1YsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSw0TUFBNE07aUJBQzVOO2dCQUNELFlBQVksRUFBRTtvQkFDWixNQUFNLEVBQUUsUUFBUTtvQkFDaEIsYUFBYSxFQUFFLHFFQUFxRTtpQkFDckY7Z0JBQ0QsU0FBUyxFQUFFO29CQUNULE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsbUlBQW1JO2lCQUNuSjthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLFVBQVU7Z0JBQ1YsWUFBWTthQUNiO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=